import { render, staticRenderFns } from "./CarNotes.vue?vue&type=template&id=aa045fb2&scoped=true&"
import script from "./CarNotes.vue?vue&type=script&lang=js&"
export * from "./CarNotes.vue?vue&type=script&lang=js&"
import style0 from "./CarNotes.vue?vue&type=style&index=0&id=aa045fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa045fb2",
  null
  
)

export default component.exports